export enum DrugScheduleEnum {
    C2 = 2,
    C3,
    C4,
    C5,
    MISC,
    Compound,
    //Only for filtering purpose, made up of CIVs and CVs. When recording a transaction, this is not a valid schedule!
    CAList = 11
}

export enum DrugScheduleFilterEnum {
    'Schedule II' = 2,
    'Schedule III',
    'Schedule IV',
    'Schedule V',
    'MISC',
    'Compound',
    //Only for filtering purpose, made up of CIVs and CVs. When recording a transaction, this is not a valid schedule!
    'CA List' = 11
}